"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var core_1 = require("@material-ui/core");

var formik_1 = require("formik");

var react_1 = __importDefault(require("react"));

var BB8Lookup_1 = __importDefault(require("./BB8Lookup"));

var BB8FormLookupField = function BB8FormLookupField(props) {
  return react_1.default.createElement(formik_1.Field, __assign({
    name: props.name,
    validate: props.validate
  }, props), function (_a) {
    var field = _a.field,
        form = _a.form;
    return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(core_1.FormHelperText, {
      error: !props.disabled && (!!props.error || !!(form.touched[field.name] && form.errors[field.name]))
    }, props.label), react_1.default.createElement(BB8Lookup_1.default, __assign({
      id: props.id,
      placeholder: props.placeholder,
      onInputBlur: form.handleBlur,
      // tslint:disable-next-line:jsx-no-lambda
      onSelect: function onSelect(value) {
        if (props.valuePath) {
          form.setFieldValue(field.name, value ? value[props.valuePath] : props.defaultValue ? props.defaultValue[props.valuePath] : undefined);
        } else {
          form.setFieldValue(field.name, value || props.defaultValue);
        }
      },
      options: props.options
    }, props, field)), react_1.default.createElement(core_1.FormHelperText, {
      className: "margin-20-top rem-1-font",
      error: !props.disabled && (!!props.error || !!(form.touched[field.name] && form.errors[field.name]))
    }, form.errors[field.name] && !!form.touched[field.name] ? form.errors[field.name] : ''));
  });
};

exports.default = BB8FormLookupField;